import { render } from "./form-item.vue?vue&type=template&id=953e12f2"
import script from "./form-item.vue?vue&type=script&setup=true&lang=js"
export * from "./form-item.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./form-item.vue?vue&type=style&index=0&id=953e12f2&module=true&lang=css"
cssModules["$style"] = style0
if (module.hot) {
  module.hot.accept("./form-item.vue?vue&type=style&index=0&id=953e12f2&module=true&lang=css", () => {
    cssModules["$style"] = style0
    __VUE_HMR_RUNTIME__.rerender("953e12f2")
  })
}

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__file',"resources/js/common/shared/components/form-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "953e12f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('953e12f2', __exports__)) {
    api.reload('953e12f2', __exports__)
  }
  
  module.hot.accept("./form-item.vue?vue&type=template&id=953e12f2", () => {
    api.rerender('953e12f2', render)
  })

}


export default __exports__